import __request__ from "routing/request";
export function substringTester(begin_index, end_index, string, requestOptions) {
  return __request__("GET", "/tools/substring_tester", null, { "begin_index": begin_index, "end_index": end_index, "string": string }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function testSubstring(JSONbody, requestOptions) {
  return __request__("POST", "/tools/substring_tester", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
